import React, { useEffect } from "react";

export default function PayPalDonateButton() {
  useEffect(() => {
    // Verifica si ya existe el script
    if (!document.getElementById("paypal-donate-sdk")) {
      const script = document.createElement("script");
      script.src = "https://www.paypalobjects.com/donate/sdk/donate-sdk.js";
      script.charset = "UTF-8";
      script.id = "paypal-donate-sdk";
      script.onload = () => {
        if (window.PayPal && window.PayPal.Donation) {
          window.PayPal.Donation.Button({
            env: "production",
            hosted_button_id: "C5YHWZ6MC6YLU",
            image: {
            src:"assets/images/donaPay.png",
              alt: "Donate with PayPal button",
              title: "PayPal - The safer, easier way to pay online!",
            },
          }).render("#donate-button");
        }
      };
      document.body.appendChild(script);
    } else {
      // Si el script ya está cargado, renderiza directamente
      if (window.PayPal && window.PayPal.Donation) {
        window.PayPal.Donation.Button({
          env: "production",
          hosted_button_id: "C5YHWZ6MC6YLU",
          image: {
            src:"assets/images/donaPay.png",
            alt: "Donate with PayPal button",
            title: "PayPal - The safer, easier way to pay online!",
          },
        }).render("#donate-button");
      }
    }
  }, []);

  return (
    <div id="donate-button-container">
      <div  id="donate-button"></div>
    </div>
  );
}
